import { ENABLED_MODULES } from '@/env';
import { protectedRoute } from '@/modules/core/root/protected/route';
import {
  AuthorizationError,
  NotFoundError,
  RouteErrorHandler,
} from '@/shared/components/route-error-handler';
import { createRoute } from '@tanstack/react-router';

import { SalesLayout } from './layout';

export const salesRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'sales',
  component: SalesLayout,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new AuthorizationError('User is not an admin');
    }
    if (!ENABLED_MODULES.includes('sales')) {
      throw new NotFoundError('Sales module is not available for this client');
    }
  },
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="sales" />;
  },
});
